export enum ConvertValueType {
    SECONDS = 'SECONDS',
    FLOAT = 'FLOAT'
}
